import React from "react";
import {
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const FieldValueProvided = ({milestone}) => {
  const newValue = milestone.details.new === 'Y' ?
    'YES'
  : milestone.details.new === 'N' ?
    'NO'
  : milestone.details.field.includes('Rate') ?
    `${milestone.details.new}%`
  : milestone.details.field.includes('Price')
    || milestone.details.field.includes('Amount')
    || milestone.details.field.includes('Value') ?
    `$${milestone.details.new}`
  :
    milestone.details.new

  return (
    <TimelineContent>
      <TimelineTitleRow>
        <TimelineTitle>{milestone.milestone}</TimelineTitle>
        {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
      </TimelineTitleRow>
      <TimelineMetaList>
        <TimelineMetaRow>
          <span className="timeline-meta-label">updated by:</span>
          <span className="timeline-meta-value">{milestone.contributor}</span>
        </TimelineMetaRow>
        <TimelineMetaRow>
          <span className="timeline-meta-label">date:</span>
          <span className="timeline-meta-value">{milestone.date}</span>
        </TimelineMetaRow>
        <TimelineMetaRow>
          <span className="timeline-meta-label">new value:</span>
          <span className="timeline-meta-value">{newValue}</span>
        </TimelineMetaRow>
      </TimelineMetaList>
    </TimelineContent>
  )
}

export default FieldValueProvided
